import script from "./ImageUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageUpload.vue?vue&type=script&setup=true&lang=js"

import "./ImageUpload.vue?vue&type=style&index=0&id=3273a574&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3273a574"]])

export default __exports__